export default __webpack_public_path__ + "media/images/instagram-social-ef367d51b79707d957c4e2f54ebb8bf4.svg";